module.exports = __webpack_public_path__ + "static/media/newcastle.390bb42f.png";